import { compact } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from '../../../i18next';
import { SideNavProps } from '../../../layout/PageBody';
import { useRoutes } from '../../../routes';
import { useCurrentUser } from '../../../services/currentUser';
import { useFeatureEnabled } from '../../../services/features';
import { hasPermissionToAccessPage } from '../../../services/permissions';

export const useOrgSideNav = (): SideNavProps => {
  const { t } = useTranslation();
  const { ROUTES } = useRoutes();
  const user = useCurrentUser();
  const selfCheckoutEnabled = useFeatureEnabled('SELF_CHECKOUT_V1');

  return useMemo(
    () => ({
      items: compact([
        {
          label: t('pageTitle.orgBranding'),
          route: ROUTES.org.branding
        },
        {
          label: t('pageTitle.orgIntegrations'),
          route: ROUTES.org.integrations
        },
        {
          label: t('pageTitle.orgUsersCustomFields'),
          route: ROUTES.org.customFields
        },
        {
          label: t('pageTitle.orgNotificationEmails'),
          route: ROUTES.org.notificationEmails
        },
        {
          label: t('pageTitle.orgAdminUsers'),
          route: ROUTES.org.adminUsers
        },
        selfCheckoutEnabled && {
          label: t('pageTitle.orgSubscription'),
          route: ROUTES.org.subscription
        },
        {
          label: t('pageTitle.orgAIFeatures'),
          route: ROUTES.org.aiFeatures
        }
      ])
        .filter((r) => hasPermissionToAccessPage(user, r.route))
        .map((r) => ({
          label: r.label,
          path: r.route.url()
        }))
    }),
    [ROUTES, t, user, selfCheckoutEnabled]
  );
};
